<template>
  <Modal v-model="modalState" width="90%">
    <p slot="header" style="color:#19be6b;text-align:center">
      <Icon type="android-add-circle"></Icon>
      <span>Add Detail(s)</span>
    </p>

    <Card>
      <Card>
        <Row type="flex" justify="space-between">
          <Col span="8" style="text-align:center;">
          <label for="Container Number">Container Number : </label>
          <strong>{{ dataHot.containerNumber }}</strong>
          </Col>

          <Col span="8" style="text-align:center;">
          <label for="Sum of Vol">Sum of Vol : </label>
          <strong>{{ dataHot.sumOfVol }}</strong>
          </Col>

          <Col span="8" style="text-align:center;">
          <label for="Sum of Uang Yg Akan Diterima">Sum of Uang Yg Akan Diterima : </label>
          <strong>{{ dataHot.sumOfUYAD }}</strong>
          </Col>
        </Row>
      </Card>
      <br>

      <HotTable ref="hotTableComponent" :settings="hotSettings" :data="dataHot">
      </HotTable>
    </Card>

    <div slot="footer">
      <Button :disabled="!isDataFilled" :loading="isSubmitButton" type="success" @click="actionPostDetail">
        <span v-if="!isSubmitButton">Simpan Data</span>
        <span v-else>Sedang diproses.....</span>
      </Button>
    </div>
  </Modal>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import { HotTable } from '@handsontable/vue';
import { registerAllModules } from "handsontable/registry";

import "handsontable/dist/handsontable.full.min.css";

registerAllModules();

export default {
  components: { HotTable },
  props: {
    dataHot: Object,
    isModalAddDetail: Boolean
  },
  data() {
    return {
      isDataFilled: false,
      isSubmitButton: false
    }
  },
  computed: {
    modalState: {
      get() {
        return this.isModalAddDetail;
      },
      set(val) {
        // kalau modal diclose, emit ke parent
        if (!val) this.handleClose();
      }
    }
  },
  methods: {
    getHotSettings() {
      this.hotSettings = {
        licenseKey: "non-commercial-and-evaluation",
        height: 380,
        width: "100%",
        stretchH: "all",
        filters: true,
        autoColumnSize: true,
        autoRowSize: true,
        colHeaders: true,
        rowHeaders: true,
        copyPaste: true,
        // colWidths: [150, 150, 300, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150],
        colHeaders: [
          // "CONTAINER NUMBER",
          "BRANCH",
          "SUM OF VOL",
          "SUM OF UANG YG AKAN DITERIMA",
          "PIB",
          "NOTUL",
          "OPS PELABUHAN",
          "TRUCKING",
          "DAOP",
          "DEMURRAGE",
          "RE-EXPORT",
          "KAPAL/CONT. GZ",
          "FORM E",
          "LS"
        ],
        minRows: "15",
        columns: [
          // {
          //   data: "containerNumber",
          //   type: "text",
          //   readOnly: true
          // },
          {
            data: "branch",
            type: "text",
          },
          {
            data: "sumOfVol",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "sumOfUYAD",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "pib",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "notul",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "opsPort",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "trucking",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "daop",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "demurrage",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "reExport",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "shipContGZ",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "formE",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
          {
            data: "ls",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight",
            readOnly: true
          },
        ],
        beforeChange: (changes, source) => {
          if (changes && source === 'edit') {
            changes.forEach(change => {
              let [row, prop, oldValue, newValue] = change;

              if (prop === 'branch' && typeof newValue === 'string') {
                change[3] = newValue.toUpperCase();
              }
            });
          }
        },
        afterChange: (changes, source) => {
          if (source === "loadData" || source === "updateData") return; // skip pas pertama load atau update ketika close/submit modal popup

          const hot = this.$refs.hotTableComponent.hotInstance;
          const dataHeader = this.dataHot;
          const sumOfVolHeader = this.toNumber(dataHeader.sumOfVol)
          const pibHeader = this.toNumber(dataHeader.pib);
          const notulHeader = this.toNumber(dataHeader.notul);
          const opsPortHeader = this.toNumber(dataHeader.opsPort);
          const truckingHeader = this.toNumber(dataHeader.trucking);
          const daopHeader = this.toNumber(dataHeader.daop);
          const demurrageHeader = this.toNumber(dataHeader.demurrage);
          const reExportHeader = this.toNumber(dataHeader.reExport);
          const shipContGZHeader = this.toNumber(dataHeader.shipContGZ);
          const formEHeader = this.toNumber(dataHeader.formE);
          const lsHeader = this.toNumber(dataHeader.ls);

          const isEmpty = (val) => val === null || val === "" || val === undefined || val === 0;

          changes.forEach(([row, prop, oldVal, newVal]) => {
            if (prop == 'sumOfVol' || prop == 'sumOfUYAD') {
              let sumOfVolFilled = hot.getDataAtRowProp(row, 'sumOfVol');
              console.log({ sumOfVolFilled });

              // kalau sum_of_vol atau sum_of_uyad berubah, auto calculates
              const pib = pibHeader / sumOfVolHeader * sumOfVolFilled;
              const notul = notulHeader / sumOfVolHeader * sumOfVolFilled;
              const opsPort = opsPortHeader / sumOfVolHeader * sumOfVolFilled;
              const trucking = truckingHeader / sumOfVolHeader * sumOfVolFilled;
              const daop = daopHeader / sumOfVolHeader * sumOfVolFilled;
              const demurrage = demurrageHeader / sumOfVolHeader * sumOfVolFilled;
              const reExport = reExportHeader / sumOfVolHeader * sumOfVolFilled;
              const shipContGZ = shipContGZHeader / sumOfVolHeader * sumOfVolFilled;
              const formE = formEHeader / sumOfVolHeader * sumOfVolFilled;
              const ls = lsHeader / sumOfVolHeader * sumOfVolFilled;

              hot.setDataAtRowProp(row, 'pib', isEmpty(sumOfVolFilled) ? null : Math.round(pib));
              hot.setDataAtRowProp(row, 'notul', isEmpty(sumOfVolFilled) ? null : Math.round(notul));
              hot.setDataAtRowProp(row, 'opsPort', isEmpty(sumOfVolFilled) ? null : Math.round(opsPort));
              hot.setDataAtRowProp(row, 'trucking', isEmpty(sumOfVolFilled) ? null : Math.round(trucking));
              hot.setDataAtRowProp(row, 'daop', isEmpty(sumOfVolFilled) ? null : Math.round(daop));
              hot.setDataAtRowProp(row, 'demurrage', isEmpty(sumOfVolFilled) ? null : Math.round(demurrage));
              hot.setDataAtRowProp(row, 'reExport', isEmpty(sumOfVolFilled) ? null : Math.round(reExport));
              hot.setDataAtRowProp(row, 'shipContGZ', isEmpty(sumOfVolFilled) ? null : Math.round(shipContGZ));
              hot.setDataAtRowProp(row, 'formE', isEmpty(sumOfVolFilled) ? null : Math.round(formE));
              hot.setDataAtRowProp(row, 'ls', isEmpty(sumOfVolFilled) ? null : Math.round(ls));
            }
          });

          // handle submit button
          if (changes) {
            this.$nextTick(() => {
              const allData = hot.getData();

              const isAllNullOrEmpty = allData.every(row =>
                row.every(isEmpty)
              );

              if (!isAllNullOrEmpty) {
                this.isDataFilled = true;
              } else {
                this.isDataFilled = false;
              }
            });
          }
        },
      };
    },
    toNumber(value) {
      if (typeof value === "number") return value; // sudah number
      if (typeof value !== "string") return NaN;   // bukan string / number

      // hapus semua koma (,) tapi biarkan titik (.) untuk desimal
      const cleaned = value.replace(/,/g, "").trim();

      return parseFloat(cleaned);
    },
    actionPostDetail() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      const allData = hot.getData();
      const isEmpty = (val) => val === null || val === "" || val === undefined;

      // hanya ambil row yg ada isinya
      const dataFilled = allData.filter(row => !row.every(isEmpty));

      // langsung mapping ke payload
      const bundle = dataFilled.map(data => ({
        omsetId: this.dataHot.id,
        containerNumber: this.dataHot.containerNumber,
        branch: data[0],
        sumOfVol: data[1],
        sumOfUYAD: data[2],
        pib: data[3],
        notul: data[4],
        opsPort: data[5],
        trucking: data[6],
        daop: data[7],
        demurrage: data[8],
        reExport: data[9],
        shipContGZ: data[10],
        formE: data[11],
        ls: data[12],
      }));

      console.log({ bundle });

      this.isSubmitButton = true
      HTTP
        .post('omset/create-bundle-detail', { bundle })
        .then(response => {
          console.log(response)

          this.$Message.success({
            content: 'Detail omset berhasil disimpan !',
            duration: 3
          });

          this.isSubmitButton = false
          this.$emit("dismiss-modal"); // close modal
        })
        .catch(e => {
          this.isSubmitButton = false
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },
    handleClose() {
      this.$emit("dismiss-modal");
    }
    // setAllContainerNumber(newContainerNumber) {
    //   const hot = this.$refs.hotTableComponent.hotInstance;
    //   // bikin array perubahan
    //   const changes = [];
    //   for (let row = 0; row < 50; row++) {
    //     changes.push([row, 0, newContainerNumber]); // kolom 0 = containerNumber
    //   }

    //   hot.setDataAtCell(changes);
    // }
  },

  beforeMount() {
    this.getHotSettings();
  },

  // watch: {
  //   dataHot: {
  //     deep: true,
  //     immediate: true,
  //     handler(newVal) {
  //       if (newVal && newVal.containerNumber) {
  //         this.$nextTick(() => {
  //           this.setAllContainerNumber(newVal.containerNumber)
  //         })
  //       }
  //     }
  //   }
  // }
}

</script>



// WEBPACK FOOTER //
// cHotOmsetAddDetail.vue?605efbde